import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';

/**
 * Loading placeholder matching a loading `MetricChart` (its `SkeletonBox`). Fills its
 * container, which is the plot area of a fixed-height card.
 */
export default function HealthDetailChartSkeleton() {
    return <SkeletonBox width="100%" height="100%" borderRadius={8} />;
}
